import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-blog-version23',
  templateUrl: './blog-version23.component.html',
  styleUrls: ['./blog-version23.component.scss']
})
export class BlogVersion23Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
